// What is specific to problem kendaraan trado (the normal one is in problem-kendaraan/utils)
const problemKendaraanTradoConfig = {
  title: "Problem Trado",
  // filter jenis of the problem list
  jenis: "trado",

  // columns "#" and "DESKRIPSI" (mobile) that can be sorted, per table (new = last 7 days, old = older)
  sortable: {
    new: { no: true, description: false },
    old: { no: true, description: true },
  },

  // "Lihat Cek": the pages the problem came from
  pengecekanUrl: (pemakaianMobilId) =>
    `/transaksi/cek-keluar-masuk-trado/kembali/${pemakaianMobilId}`,
  auditUrl: (auditKendaraanId) =>
    `/audit/audit-kendaraan-trado/edit/${auditKendaraanId}`,

  // "Group" column: label_grup shown as text ("gambar box" is the trailer photo)
  formatLabelGrup: (labelGrup) => {
    let _labelGrup = labelGrup.replaceAll("_", " ");
    _labelGrup = _labelGrup.replaceAll("gambar box", "Gambar trailer");
    return _labelGrup;
  },
};

export default problemKendaraanTradoConfig;
